let workerInstance = null;

export const getChartWorker = () => {
    if (!workerInstance) {
        const workerBlob = new Blob([`
            let lastPayload = null;
            let isTabActive = true;

            const sendData = () => {
                if (lastPayload) {
                    postMessage({ type: "WE_PRICE", payload: [lastPayload, isTabActive] });
                    lastPayload = null;
                }
            };

            onmessage = (e) => {
                if (e.data.type === "WE_PRICE") {
                    [lastPayload, isTabActive] = e.data.payload;
                    if (!isTabActive) {
                        if (lastPayload.second === 1) {
                            sendData();
                        }
                    } else {
                        sendData();
                    }
                }
            };
        `], { type: "application/javascript" });

        const workerUrl = URL.createObjectURL(workerBlob);
        workerInstance = new Worker(workerUrl);
    }

    return workerInstance;
};